"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectSchema = exports.hasTeamRole = exports.isPrivilegedUserRole = exports.castToTeamRole = exports.TeamRoleSchema = exports.TeamRole = exports.castToUserRole = exports.UserRoleSchema = exports.UserRole = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["CSE"] = "CSE";
    UserRole["DEVELOPER"] = "DEVELOPER";
    UserRole["MANAGER"] = "MANAGER";
    UserRole["USER"] = "USER";
    UserRole["API"] = "API";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
exports.UserRoleSchema = (0, core_1.StringUnion)([
    UserRole.ADMIN,
    UserRole.CSE,
    UserRole.DEVELOPER,
    UserRole.MANAGER,
    UserRole.USER,
    UserRole.API,
], {
    title: "User roles",
    description: "Role of a user",
});
exports.castToUserRole = (0, cast_1.castToEnum)(UserRole);
var TeamRole;
(function (TeamRole) {
    TeamRole["OWNER"] = "OWNER";
    TeamRole["WRITER"] = "WRITER";
    TeamRole["READER"] = "READER";
})(TeamRole = exports.TeamRole || (exports.TeamRole = {}));
exports.TeamRoleSchema = (0, core_1.StringUnion)([TeamRole.OWNER, TeamRole.WRITER, TeamRole.READER], {
    title: "Team roles",
    description: "Roles a user in a team",
});
exports.castToTeamRole = (0, cast_1.castToEnum)(TeamRole);
function isPrivilegedUserRole(role) {
    // Basically everyone except a user can do anything, and a manager can do anything in the team
    return (role === UserRole.ADMIN ||
        role === UserRole.CSE ||
        role === UserRole.DEVELOPER);
}
exports.isPrivilegedUserRole = isPrivilegedUserRole;
function hasTeamRole(role, desiredRole) {
    // If they have no declared role, they have no role
    if (!role) {
        return false;
    }
    // If they have a role, and we have no minimum role, they have the role
    if (!desiredRole) {
        return true;
    }
    switch (desiredRole) {
        case TeamRole.OWNER:
            return role === TeamRole.OWNER;
        case TeamRole.WRITER:
            return role === TeamRole.WRITER || role === TeamRole.OWNER;
        case TeamRole.READER:
            return true;
    }
}
exports.hasTeamRole = hasTeamRole;
exports.SubjectSchema = typebox_1.Type.String({
    title: "Subject",
    description: "A unique (external) identifier for the user",
});
